export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const FETCH_LIST = "FETCH_LIST";

export const login = (user) => ({
  type: LOGIN,
  payload: user,
});

export const logout = () => ({
  type: LOGOUT,
});

export const fetch_list = (list) => ({
  type: FETCH_LIST,
  payload: list,
});
